import { Injectable, OnDestroy } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface ReportNotification {
  jobId: string;
  status: 'Queued' | 'Processing' | 'Completed' | 'Failed';
  fileName: string | null;
  errorMessage: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class ReportHubService implements OnDestroy {
  private hubConnection!: signalR.HubConnection;
  private reportStatus$ = new Subject<ReportNotification>();
  public reportStatusChanged$ = this.reportStatus$.asObservable();

  constructor(private authService: AuthService) {
    this.startConnection();
  }

  private startConnection(): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.signalRUrl}/reportHub`, {
        accessTokenFactory: () => this.authService.getAccessToken() || ''
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.start()
      .then(() => console.log('ReportHub connected'))
      .catch(err => console.error('ReportHub connection error:', err));

    this.hubConnection.on('ReportStatusChanged', (notification: ReportNotification) => {
      this.reportStatus$.next(notification);
    });

    this.hubConnection.onreconnecting(() => {
      console.warn('ReportHub reconnecting...');
    });

    this.hubConnection.onreconnected(() => {
      console.log('ReportHub reconnected');
    });
  }

  ngOnDestroy(): void {
    this.hubConnection?.stop();
  }
}
